<template>
  <div id="app">
    <game />
  </div>
</template>

<script>
import Game from '@/components/game.vue'

export default {
  components: {
    Game
  }
}
</script>

<style>
html,
body {
  overflow: hidden;
}

body {
  margin: 0;
  padding: 0;
  min-width: 100%;
  min-height: 100vh;
  background: #000;
  display: flex;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  margin: auto;
}
</style>
